import { render, staticRenderFns } from "./sosrecord.vue?vue&type=template&id=1da00028&scoped=true"
import script from "./sosrecord.vue?vue&type=script&lang=js"
export * from "./sosrecord.vue?vue&type=script&lang=js"
import style0 from "./sosrecord.vue?vue&type=style&index=0&id=1da00028&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da00028",
  null
  
)

export default component.exports